import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import Slider from 'react-slick';

import {diamondImgUrl, diamondTitle, diamondPrice} from '../../../../../../utils/formatting';
import {getProductUrl, getMinPrice} from '../../../../../../utils/product';
import {cloneArray} from '../../../../../../utils/data';
import {getJsonFromUrl} from '../../../../../../utils/url';

import * as productActionCreators from '../../../../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);

import {ResultsControlsContainer} from '../ResultsControls';
import {ResultsPaginationContainer} from '../ResultsPagination';
import RhinoLoading from '../../../../common/RhinoLoading';

class ProductGrid extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {

    super(props);

    // let urlData = getJsonFromUrl();
    // let hasQuerystring = Object.entries(urlData).length > 0 && urlData.constructor === Object;

    // let startingPage = '';
    // if(hasQuerystring && urlData.p) {
    //   startingPage = urlData.q;
    // }


    this.state = {

    };
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getProductMainImage(product) {
    if(product.image_count > 0) {
      return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
    }
  }

  prevPage() {
    this.props.productSetPage(this.props.product.currentPage - 1);
    this.props.scrollUp();
  }

  nextPage() {
    this.props.productSetPage(this.props.product.currentPage + 1);
    this.props.scrollUp();
  }

  setPage(pageNum) {
    this.props.productSetPage(parseInt(pageNum));
    this.props.scrollUp();
  }

  getSearchQueryString() {
    if(!this.props.searchQuery) {
      return '';
    }

    const pageVal = this.props.product.currentPage && this.props.product.currentPage > 1 ? `&p=${this.props.product.currentPage}` : '';

    return '?q=' + encodeURIComponent(this.props.searchQuery) + pageVal;
  }

  render() {

    const RESULT_LIMIT = 24;
    let pCount = 0;

    console.log(this.props.product.currentPage);

    return <div className='ProductGrid'>
      <ResultsControlsContainer
        resultCount={this.props.productCount}
        resultType={'generic'}
        updateMethod={::this.props.updateMethod} />
      <div className='resultItemsWrapper'>
        {!this.props.searchPending ?
          <div>
            {this.props.products.length === 0 ?
              <div className='resultItemsNoResults'>No jewelry found. Please adjust your search and try again.</div> :
              <div>
                {this.props.products.map((product, j) => {
                
                  if(product.image_count === 0 || pCount >= RESULT_LIMIT * this.props.product.currentPage) {
                    return null;
                  }

                  if(pCount < RESULT_LIMIT * (this.props.product.currentPage - 1)) {
                    pCount++;
                    return null;
                  }

                  pCount++;

                  if(product.product_type === 'diamond') {
                    return <div className={'productBannerItem'} key={j}>
                      <Link to={'/diamond/' + product.id}>
                        <div className='productItemInnerWrapper'>
                          <div className='diamondItemImgWrapper'>
                            <img src={product.image} />
                          </div>
                          <div className='productItemTitle'><div>{diamondTitle(product)}</div></div>
                          <div className='diamondItemPrice'>
                            ${product.price.toLocaleString()}
                          </div>
                        </div>
                      </Link>
                    </div>
                  }

                  return <div className={'productBannerItem'} key={j}>
                    <Link to={'/' + getProductUrl(product) + this.getSearchQueryString()}>
                      <div className='productItemInnerWrapper'>
                        <div className='diamondItemImgWrapper'>
                          <img src={this.getProductMainImage(product)} />
                        </div>

                        <div className='productItemTitle'>
                          <div>{product.name.replace(/Ã©/g, 'é')}</div>
                        </div>

                        <div className='diamondItemPrice'>
                          ${getMinPrice(product).toLocaleString()}
                        </div>
                      </div>
                    </Link>
                  </div>
                })}
                <ResultsPaginationContainer
                  pageNum={parseInt(this.props.product.currentPage)}
                  pageNext={::this.nextPage}
                  pagePrev={::this.prevPage}
                  setPage={::this.setPage}
                  pageSize={RESULT_LIMIT}
                  isSearchPage={true}
                  searchItems={this.props.products}
                  resultCount={pCount} />
              </div>
            }
          </div> :
          <RhinoLoading />
        } 
      </div>
    </div>;
  }
}
export default ProductGrid;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const ProductGridContainer = connect(
  mapStateToProps,
  allActionCreators
)(ProductGrid);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/results/grids/ProductGrid.jsx